import React from 'react';
import PropTypes from 'prop-types';

const SkillIcon = ({ width, height, fill }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 18.583">
        <g fill={fill}>
            <path d="M15.785 9.135L14.162 6.67a.417.417 0 01-.059-.235 7.066 7.066 0 00-14.1.626 8.086 8.086 0 002.8 6.005.178.178 0 01.078.156V16.9a1.194 1.194 0 001.1 1.193l5.536.489h.1a1.212 1.212 0 00.8-.313 1.188 1.188 0 00.391-.88V15.1h1.6a1.724 1.724 0 001.721-1.721v-2.151h.528a1.374 1.374 0 001.193-.7 1.406 1.406 0 00-.065-1.393zm-1.135.822h-.939a.835.835 0 00-.841.841v2.6a.443.443 0 01-.45.45h-1.935a.939.939 0 00-.939.939v2.523l-5.38-.41v-3.677a1.48 1.48 0 00-.528-1.115 6.828 6.828 0 01-2.367-5.047 5.791 5.791 0 0111.56-.509 1.68 1.68 0 00.254.782l1.643 2.582a.121.121 0 01-.077.04z" />
            <path d="M10.68 6.318h-.606a3.8 3.8 0 00-.293-.7l.43-.43a.272.272 0 000-.372l-.822-.8a.272.272 0 00-.372 0l-.43.43a3.8 3.8 0 00-.7-.293v-.606a.259.259 0 00-.254-.254H6.494a.259.259 0 00-.254.254v.606a3.8 3.8 0 00-.7.293l-.45-.43a.272.272 0 00-.372 0l-.8.8a.272.272 0 000 .372l.43.43a3.8 3.8 0 00-.293.7h-.606a.259.259 0 00-.254.254v1.154a.259.259 0 00.254.254h.606a3.8 3.8 0 00.293.7l-.43.43a.272.272 0 000 .372l.8.8a.272.272 0 00.372 0l.43-.43a3.8 3.8 0 00.7.293v.606a.259.259 0 00.254.254h1.135a.259.259 0 00.254-.254v-.606a3.8 3.8 0 00.7-.293l.43.43a.272.272 0 00.372 0l.8-.8a.272.272 0 000-.372l-.43-.43a3.8 3.8 0 00.293-.7h.606a.259.259 0 00.254-.254V6.592a.216.216 0 00-.208-.274zM7.061 8.939a1.78 1.78 0 111.78-1.78 1.787 1.787 0 01-1.78 1.78z" />
            <circle cx=".939" cy=".939" r=".939" transform="translate(6.122 6.22)" />
        </g>
    </svg>
);

SkillIcon.propTypes = {
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    fill: PropTypes.string
};

SkillIcon.defaultProps = {
    width: '16',
    height: '18.583',
    fill: '#4b254e'
};

export default SkillIcon;
